import { UseQueryResult } from '@tanstack/react-query';
import { useApiQuery } from 'api/use-api-query';
import { useAuth } from 'auth';
import { AxiosResponse } from 'axios';
import { ZendeskApi, ZendeskAuthResponse } from 'oas';
import { isEmailValid } from 'reporting/helpers';

export const useGetZendeskAuth = (options = {}): UseQueryResult<ZendeskAuthResponse> | undefined => {
    const { user } = useAuth();

    return useApiQuery(
        ['zendesk-auth', user?.id],
        async (apiConfig, axiosInstance) => {
            // it's possible for users to have their email field set to something that isn't actually an email
            // in this case, we don't want to do the request because it is guaranteed to fail
            if (user?.email && isEmailValid(user?.email)) {
                return await new ZendeskApi(apiConfig, '', axiosInstance).getZendeskUserJWT(options);
            } else {
                return Promise.resolve() as unknown as Promise<AxiosResponse<ZendeskAuthResponse>>;
            }
        },
        {
            staleTime: 7 * 60 * 1000,
            enabled: !!user?.id,
            ...options,
        },
    );
};
